// extracted by mini-css-extract-plugin
export default {"users-header":"Users_users-header__vnySb","users-control":"Users_users-control__GK7rQ"};